import script from "./ListarTurmasInstrutor.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarTurmasInstrutor.vue?vue&type=script&setup=true&lang=js"

import "./ListarTurmasInstrutor.vue?vue&type=style&index=0&id=354ef100&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-354ef100"]])

export default __exports__